export const initHeroContact = () => {
  const heroFormCols = document.querySelectorAll(
    '.hero.secondary-hero.contact .et_pb_row .et_pb_column',
  );
  const heroFormModules = document.querySelectorAll(
    '.hero.secondary-hero.contact .et_pb_row .et_pb_column .et_pb_module',
  );
  const formCode = document.querySelector(
    '.hero.secondary-hero.contact .et_pb_row .et_pb_column .et_pb_module .et_pb_code_inner',
  );

  if (heroFormCols.length === 1) {
    console.log('test');
    heroFormCols[0].style.flexDirection = 'column';
    heroFormModules.forEach((module) => {
      module.style.bottom = '0';
      module.style.width = '100%';
    });

    formCode.style.width = '100%';
  }
};
